import type { IModalBarProps } from "@bonusx-global/bx-design-system";
import { ModalBar } from "@bonusx-global/bx-design-system";
import { TimesSolid } from "@bonusx-global/bx-icons";
import { useAtomValue } from "jotai";
import { useModal } from "../../hooks/useDialog";
import { useQuestionnaireStepperPercentage } from "../../hooks/useQuestionnaireStepperPercentageStore";
import { HeaderStore } from "../../stores/header";
import type { ConfirmExitFromQuestionnaireProps } from "../poppers/ConfirmExitFromQuestionnaire";
import ConfirmExitFromQuestionnaire from "../poppers/ConfirmExitFromQuestionnaire";

export const QUESTIONNAIRE_HEADER_ID = "questionnaire-header";

interface QuestionnaireHeaderProps extends ConfirmExitFromQuestionnaireProps, Omit<IModalBarProps, "title"> {
  title?: string;
}

function QuestionnaireHeader({ title, closeButtonURL, ...rest }: Readonly<QuestionnaireHeaderProps>): JSX.Element {
  const headerStore = useAtomValue(HeaderStore);
  const { open } = useModal({
    children: <ConfirmExitFromQuestionnaire closeButtonURL={closeButtonURL} />,
  });

  const { currentPercentage } = useQuestionnaireStepperPercentage();

  return (
    <ModalBar
      id={QUESTIONNAIRE_HEADER_ID}
      title={title ?? headerStore.title ?? ""}
      endIcon={<TimesSolid />}
      onEndIconClick={open}
      progressBar
      progressValue={currentPercentage}
      progressColor="secondary"
      {...rest}
    />
  );
}

export default QuestionnaireHeader;
